//@libs
import PropTypes from "prop-types";
//@mui-material
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
//@components
import IconButton from "./";

const DownloadButton = ({
  title = "Descargar",
  icon = null,
  ...props
}) => {
  return (
    <IconButton
      sx={{
        "&:hover": {
          color: "#FF0000",
          transform: "scale(1.1)",
        },
      }}
      title={title}
      icon={icon || <InsertDriveFileIcon />}
      {...props}
    />
  );
};

DownloadButton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.node,
};

export default DownloadButton;
